/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Min_CharactersInputs */

const en_dialog_min_characters = /** @type {(inputs: Dialog_Min_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please write at least 30 characters`)
};

const es_dialog_min_characters = /** @type {(inputs: Dialog_Min_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor escribe al menos 30 caracteres`)
};

/**
* | output |
* | --- |
* | "Please write at least 30 characters" |
*
* @param {Dialog_Min_CharactersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_min_characters = /** @type {((inputs?: Dialog_Min_CharactersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Min_CharactersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_min_characters(inputs)
	return en_dialog_min_characters(inputs)
});